import { get } from 'lodash';
import Platform from 'platform';
import keys from 'config/keys';

const getTermsSelector = state => get(state, ['terms', 'data']);

export default state => {
  return {
    terms: getTermsSelector(state),
    downKeyCode: Platform.getKeyCode(keys.DOWN),
    upKeyCode: Platform.getKeyCode(keys.UP),
  };
};
